import { render, staticRenderFns } from "./GapDocumentList.vue?vue&type=template&id=32676ac6&scoped=true&"
import script from "./GapDocumentList.vue?vue&type=script&lang=ts&"
export * from "./GapDocumentList.vue?vue&type=script&lang=ts&"
import style0 from "./GapDocumentList.vue?vue&type=style&index=0&id=32676ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32676ac6",
  null
  
)

export default component.exports